
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import {
  refundDetail,
  cancelRefund,
  uploadFile,
  refundGoods,
  getDataRefund
} from '@/services/http';
import { dateTimeFormatter, writeStorage, readCookie } from '@/tools/tools';
import CountDown from '@/components/countdown/index.vue';

@Component({
  components: {
    Header,
    Price,
    Footer,
    NavMenu,
    CountDown
  },
  filters: {
    dateTimeFormatter(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  // 详情信息列表
  detailList: any = {}

  // 服务单详情状态
  status: number = -1

  pointList: [] = []

  refundId: string = ''

  // 申请类别(1仅退款  2退货退款  3换货)
  applyType: number = -1

  applyName: string = ''

  // 退款、退货退款是否有财务审批
  isFinance: boolean = false

  // 是否有取消申请(仅退款审核后不能取消申请，退货退款以及换货后填写物流单号后不能取消申请)
  withdraw: boolean = false

  statusStr: string = ''

  //  上传图片列表
  fileList: any[] = []

  // 上传图片id
  imgids: string = ''

  // 是否上传到最大数量
  maxpic: boolean = false

  //  物流公司
  logisticsCompany: string = ''

  // 物流单号
  logisticsNo: string = ''

  refundGiftType: number = 0 //0-无需退回实物赠品1-需退回实物赠品

  @Mutation('exchange/SAVEINFORLIST') SAVEINFORLIST!: Function

  async created() {
    await this.refundDetail();
  }

  mounted() {}

  checkOrder() {
    this.$router.push(`/order-details?id=${this.$route.query.id}`);
  }

  private async refundDetail() {
    const res: any = await refundDetail({
      refundId: this.$route.query.id
    });
    this.detailList = res.data.data;
    this.pointList = res.data.data.mallOrderRefund.detailList;
    this.status = res.data.data.mallOrderRefund.status;
    this.refundId = res.data.data.mallOrderRefund.id;
    this.applyType = res.data.data.mallOrderRefund.applyType;
    this.isFinance = res.data.data.mallOrderRefund.applyAmount
      >= res.data.data.mallAfterSaleRule.financeVerifyAmount;
    this.refundGiftType = res.data.data.refundGiftType;
    if (this.applyType === 1) {
      if (this.status === 2) {
        this.statusStr = '申请失败';
      } else if (this.status === 3) {
        this.statusStr = '已完成';
      } else if (this.status === 7) {
        this.statusStr = '已取消';
      } else {
        this.statusStr = '处理中';
      }
      this.applyName = '仅退款';
      if (this.status === 0) {
        this.withdraw = true;
      } else {
        this.withdraw = false;
      }
    } else if (this.applyType === 2) {
      if (this.status === 2) {
        this.statusStr = '申请失败';
      } else if (this.status === 3) {
        this.statusStr = '已完成';
      } else if (this.status === 7) {
        this.statusStr = '已取消';
      } else {
        this.statusStr = '处理中';
      }
      this.applyName = '退货退款';
      if (
        res.data.data.mallOrderRefund.refundLogisticsName === null
        && this.status !== 7
        && this.status !== 2
      ) {
        this.withdraw = true;
      } else {
        this.withdraw = false;
      }
    } else {
      this.applyName = '换货';
      if (
        res.data.data.mallOrderRefund.refundLogisticsName === null
        && this.status !== 7
        && this.status !== 2
      ) {
        this.withdraw = true;
      } else {
        this.withdraw = false;
      }
      if (this.status === 2) {
        this.statusStr = '申请失败';
      } else if (this.status === 6) {
        this.statusStr = '已完成';
      } else if (this.status === 7) {
        this.statusStr = '已取消';
      } else {
        this.statusStr = '处理中';
      }
    }
  }

  // 复制成功
  private onCopy() {
    this.$message.success('复制成功！');
  }

  // 复制失败
  private onError() {
    this.$message.error('该浏览器不支持自动复制,请手动复制！');
  }

  private fillin() {
    const obj = {
      sourceUrl: this.detailList.mallOrderRefund.productImage.sourceUrl,
      productName: this.detailList.mallOrderRefund.productName,
      natureList: this.detailList.mallOrderRefund.natureList,
      price: this.detailList.mallOrderDetail.price,
      buyNum: this.detailList.mallOrderDetail.buyNum
    };
    this.SAVEINFORLIST(obj);
    this.$router.push({
      name: 'ExChangeLogisticsInformation',
      query: {
        id: this.refundId
      }
    });
  }

  // 再次提交申请售后
  private async applyRefund() {
    const obj = [
      {
        id: this.detailList.mallOrderDetail.id,
        buyNum: this.detailList.mallOrderDetail.buyNum,
        applyNum: this.detailList.mallOrderRefund.applyNum,
        price: this.detailList.mallOrderDetail.price,
        product_name: this.detailList.mallOrderRefund.productName,
        norms: this.detailList.mallOrderRefund.natureList,
        orderNo: this.detailList.mallOrderDetail.orderNo,
        mallImage: this.detailList.mallOrderRefund.productImage.sourceUrl,
        applyReasonDesc: this.detailList.mallOrderRefund.applyReasonDesc,
        applyReasonId: this.detailList.mallOrderRefund.applyReasonId,
        applyType: this.detailList.mallOrderRefund.applyType,
        applyImage: this.detailList.mallOrderRefund.applyImage
      }
    ];
    writeStorage('exchangeList', obj);
    this.$router.push({
      path: `/exchange?id=${this.detailList.mallOrderDetail.id}&refundId=${this.$route.query.id}&orderNo=${this.detailList.mallOrderDetail.orderNo}`
    });
  }

  // 取消申请
  cancelRefund() {
    this.$msgbox({
      title: '确定取消申请？',
      message: `您将取消本次${this.applyName}申请，如果问题未解决，您还可以再次发起，确定继续吗？`,
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          const res: any = await cancelRefund({
            refundId: this.refundId
          });
          if (res.data.code === 100) {
            const anchor = readCookie('anchor');
            getDataRefund({
              refundingNum: '',
              equip: anchor ? anchor.equip : 4,
              version: anchor ? anchor.version : '',
              src: anchor ?(anchor.src?anchor.src:2):4,
              model: anchor ? anchor.model : '',
              equipVersion: anchor ? anchor.equipVersion : '',
              equipMeid: anchor ? anchor.equipMeid : '',
              eventNo: '3.2.2.2.1.1.1',
              companyId: 1
            });
            this.refundDetail();
            this.$message.success('取消成功');
          } else {
            this.$message.error(res.data.message);
          }
          done();
        } else {
          done();
        }
      }
    });
  }

  // 上传图片
  private async uploadpic(event: any) {
    const file = [...event.target.files];
    if (this.fileList.length < 1) {
      const uploadlength = 1 - this.fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.fileList = res.data.data.slice(0, uploadlength);
        this.maxpic = true;
        this.imgids = this.fileList.map((e) => e.id).join(',');
      } else {
        this.$message.error(res.data.message);
      }
    }
  }

  // 删除图片
  private removefile(index: number) {
    this.fileList.splice(index, 1);
    this.maxpic = false;
  }

  // 提交物流信息
  private async refundGoods() {
    const { id } = this.$route.query;
    if (this.logisticsCompany !== '' && this.logisticsNo !== '') {
      this.$msgbox({
        title: '确定提交？',
        message: '提交后不能更改，是否确认？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            const res: any = await refundGoods({
              refundId: id,
              logisticsCompany: this.logisticsCompany,
              logisticsNo: this.logisticsNo,
              voucherId: this.imgids
            });
            if (res.data.code === 100) {
              this.refundDetail();
            } else {
              this.$message.error(res.data.message);
            }
            done();
          } else {
            done();
          }
        }
      });
    }
  }
}
